import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { useChannel } from "components/_hooks/useChannel";
import { globalObject } from "helpers/globalObject";
import { isLoading } from "helpers/requestStateHelper";
import { getCurrentVendor, mapToMerchandiseVendors } from "helpers/vendorHelper";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { oidc } from "services/oidcService";

export const Xsell = () => {
  const [showXsell, setShowXsell] = useState(true);
  const [xSellInitialized, setXSellInitialized] = useState(false);
  const channel = useChannel();

  useEffect(() => {
    (async () => {
      if (isLoading(channel) || xSellInitialized) {
        return;
      }

      const token = await oidc.getAccessToken();

      if (!channel.Vendor || !window.XSellFrontend || globalObject.disableXsell) {
        setShowXsell(false);
        return;
      }

      const vendor = mapToMerchandiseVendors(getCurrentVendor());

      const Xsell = new window.XSellFrontend.construct({
        vendorId: channel.Vendor.ID,
        channel: vendor,
        page: "mypage",
        accessToken: function() {
          return "bearer " + token;
        },
        template: "mypage-portrait-arc-3",
        aaLocation: "MyPage",
        responsiveElement: document.getElementById("xSellContainer"),
        productListCallback: function() {
          document.getElementById("xSellContainer").style.display = "none";
          document.getElementById("xSellTitle").style.display = "none";
        },
        language: channel.Vendor.Locale
      });

      Xsell.injectInto(document.getElementById("xSellContainer"));
      setXSellInitialized(true);
    })();
  }, [channel]);

  if (!showXsell) return null;

  return (
    <div>
      <h2 id="xSellTitle" className="arc3-margin-phone--left">
        <FormattedMessage id="xsell.title" defaultMessage="Recommended for you" />
      </h2>
      <div id="xSellContainer" data-cy="xSellContainer">
        <div className="center-content arc3-margin--top-xl">
          <Loader data-cy="Loader" size="extra-large" container={false} />
        </div>
      </div>
    </div>
  );
};
